import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Button, Modal, Typography } from '@mui/material';

import { useGlobalOrgChangeListener } from '../../../hooks/useGlobalOrgChangeListener';
import { selectPortalsWarningModal } from '../../../store/selectors/modals';

const MultiplePortalModal = () => {
  const { handleResume } = useGlobalOrgChangeListener();
  const visible = useSelector(selectPortalsWarningModal);

  return (
    <Modal open={visible.isOpen}>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 5,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Multiple Portal Sessions Detected
        </Typography>
        <Typography sx={{ mb: 3 }}>
          You currently have Portal open in another tab. Working in multiple tabs may cause data loss. You can safely
          close this tab or use the button below to return to your active organization.
        </Typography>
        <Button variant="contained" size="large" fullWidth color="primary" onClick={handleResume}>
          Resume Session Here
        </Button>
      </Box>
    </Modal>
  );
};

export default MultiplePortalModal;
